import { ShoppingCartEvent } from '@baemingo/shopping-cart-events';

import { GetMainAppData_user_permissions } from 'API/MainAppData/__queries__';
import { GetCompany_Company } from 'Components/App/__queries__';

export const SET_COMPANY = 'SET_COMPANY';
export const SET_COMPANY_DATA = 'SET_COMPANY_DATA';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_CURRENCIES = 'SET_CURRENCIES';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SHOW_NOTICE = 'SHOW_NOTICE';
export const SHOW_DRAWER = 'SHOW_DRAWER';
export const HIDE_DRAWER = 'HIDE_DRAWER';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_SUBUSER_TOKEN = 'SET_SUBUSER_TOKEN';
export const SET_LICENSES = 'SET_LICENSES';
export const SET_INTEGRATIONS = 'SET_INTEGRATIONS';
export const SET_INTEGRATION_FIELDS = 'SET_INTEGRATION_FIELDS';
export const SET_BO_LANGUAGE = 'SET_BO_LANGUAGE';
export const ADD_SHOPPING_CART_EVENT = 'ADD_SHOPPING_CART_EVENT';
export const ADD_SHOPPING_CART_EVENTS = 'ADD_SHOPPING_CART_EVENTS';
export const SET_TEMP_USER = 'SET_TEMP_USER';
export const ADD_INT_CONF_EVENT = 'ADD_CONFIG_EVENT';
export const SET_SUPER_ADMIN_USER_TYPE = 'SET_SUPER_ADMIN_USER_TYPE';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';

export const setCompany = (company: string | null) => ({
  type: SET_COMPANY,
  company,
});

export const setCompanyData = (companyData: GetCompany_Company | null) => ({
  type: SET_COMPANY_DATA,
  companyData,
});

export const setLanguages = (languages: string[]) => ({
  type: SET_LANGUAGES,
  languages,
});

export const setBOLanguage = (BOLanguage: string) => ({
  type: SET_BO_LANGUAGE,
  BOLanguage,
});

export const setCurrencies = (currencies: string[]) => ({
  type: SET_CURRENCIES,
  currencies,
});

export const setCurrency = (currency: string | null) => ({
  type: SET_CURRENCY,
  currency,
});

export const showNotice = (message: string, autoHide?: number) => ({
  type: SHOW_NOTICE,
  message,
  autoHide,
});

export const showDrawer = () => ({
  type: SHOW_DRAWER,
});

export const hideDrawer = () => ({
  type: HIDE_DRAWER,
});

export const setToken = (authToken: string | null) => ({
  type: SET_TOKEN,
  authToken,
});

export const setSubuserToken = (authToken: string | null) => ({
  type: SET_SUBUSER_TOKEN,
  authToken,
});

export const setUserRole = (role: string | null) => ({
  type: SET_USER_ROLE,
  role,
});

export const setUserId = (userId: string | null) => ({
  type: SET_USER_ID,
  userId,
});

export const setSuperAdminUserType = (
  superAdminUserType: 'BAEMINGO' | 'BARCONTROL' | 'SPAIN' | '',
) => ({
  type: SET_SUPER_ADMIN_USER_TYPE,
  superAdminUserType,
});

export const setLicenses = (licenses: any | null) => ({
  type: SET_LICENSES,
  licenses,
});

export const setIntegrations = (integrations: any | null) => ({
  type: SET_INTEGRATIONS,
  integrations,
});

export const setIntegrationFields = (fields: any[]) => ({
  type: SET_INTEGRATION_FIELDS,
  fields,
});

export const setTempUserFields = (fields: any) => ({
  type: SET_TEMP_USER,
  fields,
});

export function addIntegrationsConfigsEvent(eventData: any) {
  return {
    type: ADD_INT_CONF_EVENT,
    event: eventData,
  };
}

export type ShoppingCartEventState = ShoppingCartEvent[];
type ShoppingCartEventAction = {
  type: typeof ADD_SHOPPING_CART_EVENT;
  event: ShoppingCartEvent;
};

export function addShoppingCartEvent(event: ShoppingCartEvent): ShoppingCartEventAction {
  return {
    type: ADD_SHOPPING_CART_EVENT,
    event,
  };
}

export const setUserPermissions = (permissions: GetMainAppData_user_permissions | null) => ({
  type: SET_USER_PERMISSIONS,
  permissions,
});
